import "./processEnvPolyfill";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "react-tooltip/dist/react-tooltip.css";
import App from "./App";
import { Provider } from "react-redux";
import store, { history, persistor } from "./store/store";
import { PersistGate } from "redux-persist/es/integration/react";
import { removePreloader } from "./components/pagePreloader/pagePreloader";
import Unsupported from "./components/unsupported/unsupported";
import bowser from "bowser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const browser = bowser.getParser(window.navigator.userAgent);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const container = document.getElementById("root");
const root = createRoot(container);

if (browser.getBrowserName() !== "Internet Explorer") {
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <App History={history} />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
  removePreloader();

  // Advertise the test pages, which only exist in `vite dev` (see routers/content/product.js)
  if (import.meta.env.DEV) {
    console.log(
      "\n%c📋 Test Pages Available!",
      "color: #4a9eff; font-weight: bold; font-size: 14px"
    );
    console.log(
      "%c➜  API Product Service: %chttp://localhost:3001/test/api-product-service",
      "color: #888; font-weight: bold",
      "color: #4a9eff; text-decoration: underline"
    );
    console.log(
      "%c   Use this page to test API Product Service functionality",
      "color: #888"
    );
    console.log(
      "%c➜  Blog Service: %chttp://localhost:3001/test/blog-service",
      "color: #888; font-weight: bold",
      "color: #4a9eff; text-decoration: underline"
    );
    console.log(
      "%c   Use this page to test Blog Service functionality\n",
      "color: #888"
    );
  }
} else {
  root.render(<Unsupported />);
  removePreloader();
}

// registerServiceWorker();
